const apiClient = require('@/api/client.js')
import { ToastProgrammatic as Toast } from 'buefy'

export default {

  getJob(job_id, callback){

    if (!job_id){
      return callback('Invalid job id')
    }

    return apiClient.get('/job/' + job_id, null, callback);

  },

  getJobByHash(hash, callback){

    if (!hash){
      return callback('Invalid job hash')
    }

    return apiClient.get('/job', { hash }, callback);

  },

  getRoute(job_id, callback){

    if (!job_id){
      return callback('Invalid job id')
    }

    return apiClient.get('/job/' + job_id + '/route', null, callback);

  },

  getETA(job_id, callback){
    return apiClient.get(`/job/${job_id}/eta`, null, callback);
  },

  getBreaksByDriver(driver_id, callback){
    
    if (!driver_id){
      return callback('Invalid driver id')
    }

    apiClient.get("/employee/break/search", driver_id, callback);
  }

}



// WEBPACK FOOTER //
// ./src/components/job/service.js